module.exports = __webpack_public_path__ + "0d13fd1a837500bb8b15f4ed693214fb.png";